import { QUARANTINE_REASONS_DESC } from '@/config/constants';

const quarantineColumns = {
  productName: {
    key: 'productName',
    label: 'productName',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  labSampleCode: {
    key: 'labSampleCode',
    label: 'labSampleId',
    type: 'text',
    sortable: false,
    minWidth: 150,
  },
  customerId: {
    key: 'customerProductName',
    label: 'customerProductName',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  lot: {
    key: 'lot',
    label: 'lot',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  orderSentAt: {
    key: 'orderSentAt',
    label: 'orderDate',
    type: 'date',
    sortable: 'custom',
    minWidth: 170,
  },
  quarantineDate: {
    key: 'quarantineDate',
    label: 'quarantineDate',
    type: 'date',
    sortable: 'custom',
    minWidth: 170,
  },
  date: {
    key: 'date',
    label: 'lotDate',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  sector: {
    key: 'sector',
    label: 'sector',
    type: 'enum',
    enum: 'sectors',
    sortable: false,
    minWidth: 130,
  },
  packagesNumber: {
    key: 'packagesNumber',
    label: 'packagesNumber',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  notes: {
    key: 'notes',
    label: 'customerNotes',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  finalCustomer: {
    key: 'finalCustomer',
    label: 'finalCustomer',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  finalCustomerRef: {
    key: 'finalCustomerRef',
    label: 'finalCustomerRef',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  sampleDescription: {
    key: 'sampleDescription',
    label: 'sampleDescription',
    type: 'enum',
    enum: 'sampleDescriptions',
    sortable: false,
    minWidth: 200,
  },
  comments: {
    key: 'comments',
    label: 'sampleInstructions',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  costCenter: {
    key: 'costCenter',
    label: 'costCenter',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  quarantineComment: {
    key: 'quarantineComment',
    label: 'quarantineComment',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  source: {
    key: 'sampleId',
    label: 'quarantineSource',
    sortable: false,
    fixed: true,
    minWidth: 100,
    type: 'function-i18n',
    get: (value) =>
      value !== null
        ? 'quarantine.sourceLabel.receivedSamples'
        : 'quarantine.sourceLabel.quarantine',
  },
  reason: {
    key: 'reason',
    label: 'quarantineReason',
    sortable: false,
    fixed: true,
    minWidth: 120,
    enum: 'quarantineReasons',
    type: 'encoded',
    decode: (value) => QUARANTINE_REASONS_DESC[value],
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 130,
    buttons: [
      {
        name: 'accept',
        icon: 'fas fa-check-square',
        permissions: ['quarantineManage'],
      },
      {
        name: 'refuse',
        icon: 'fas fa-do-not-enter',
        permissions: ['quarantineManage'],
      },
      {
        name: 'edit',
        icon: 'fas fa-pencil',
        permissions: ['quarantineManage'],
        showCondition: (row) => row.sampleId === null,
      },
    ],
  },
};

export default quarantineColumns;
